/**
 * Faz o download de um arquivo a partir de um conteúdo em base64 ou URL.
 * @param linkContent Conteúdo do arquivo em base64 ou URL.
 * @param fileName Nome do arquivo para download.
 * @param type Tipo do conteúdo: 'base64' (padrão) ou 'url'.
 */
export type DownloadFile = (
  linkContent: string,
  fileName: string,
  type?: 'base64' | 'url' | 'txt'
) => Promise<void>

/**
 * Função para download de arquivos em base64 ou URL.
 */
export const downloadFile: DownloadFile = async (
  linkContent,
  fileName,
  type = 'url'
) => {
  let downloadLink: HTMLAnchorElement
  let urlFile: string
  if (linkContent && fileName) {
    if (type === 'base64') {
      urlFile = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${linkContent}`
      downloadLink = document.createElement('a')
      downloadLink.href = urlFile
      downloadLink.download = fileName
      downloadLink.click()
      downloadLink.remove()
    } else {
      const response = await fetch(linkContent)
      const blob = await response.blob()
      urlFile = URL.createObjectURL(blob)
      downloadLink = document.createElement('a')
      downloadLink.href = urlFile
      downloadLink.download = fileName
      downloadLink.click()
      downloadLink.remove()
    }
  }
}
